import { useRef, createRef, useEffect, useState } from "react";
import MainQuestion from "../../components/question/MainQuestion";
import { useDispatch, useSelector } from "react-redux";
import {
  requestAddAnswersQuiz,
  requestSubmitAnswersQuiz,
  resetQuizData,
} from "../../redux/actions/quizzesActionCreators";
import Stepper from "../../components/quiz/sideBarStepper/SideBarStepper";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import EmailDialogForm from "../../components/quiz/EmailForm";
import Tooltip from "@mui/material/Tooltip";
import LinearProgressBar from "../../components/shared/linearProgress/LinearProgress";
import { RouterPrompt } from "../../components/shared/RouterPrompt";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { translate } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import SadAvatar from "../../components/shared/sadAvatar";
import ForwardList from "./ForwardedList";
// import LanguageSelect from "../LanguageSelect";
import { getOrganizationProfileById } from "../../redux/actions/organizationProfileCreators";

const MainQuiz = ({
  data,
  initialPayload,
  is_completed,
  initialThreshold,
  pendingQuizz,
  isAllowed,
}) => {
  const orgaId = localStorage.getItem("orgaId");
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;

  const [activeStep, setActiveStep] = useState(0);
  const [stepsData, setStepsData] = useState([]);
  const [payload, setPayload] = useState(initialPayload);
  const [thresholdsPayload, setThresholdsPayload] = useState(initialThreshold);
  const [filtredUseCases, setFiltredUseCases] = useState(data?.usecases);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showPrompt, setShowPrompt] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const myRefs = useRef([]);
  const params = useParams();
  const { pathname } = useLocation();
  const answers = useSelector((state) => state.quizzes.answers);
  const { isAuth } = useSelector((state) => state.user);
  if (data.usecases && data.usecases.length) {
    myRefs.current = data.usecases[activeStep].questions.map(
      (element, i) => myRefs.current[i] ?? createRef(),
    );
  }
  const { quizId } = useParams();
  const routerForCompletedQuizes = [`/completed_quizzes/${quizId}`];
  const quizDisabed = routerForCompletedQuizes.includes(pathname);
  const allUsers = useSelector((state) => state?.quizzes.associatedUser);
  const forwardedUseCaseQuizzData = useSelector(
    (state) => state?.quizzes?.selected?.forwarded_question?.forwarded_usecases,
  );

  const isMobile = useMediaQuery("(max-width:900px)");
  const [isOpen, setIsOpen] = useState(false);
  const [forwarded, setForwarded] = useState([]);
  const [forwardedUseCase, setForwardedUseCase] = useState([]);
  const [forwardedUseCaseQuestions, setForwardedUseCaseQuestions] = useState(
    [],
  );
  const [currentUseCase, setcurrentUseCase] = useState(null);
  const [pourcentageQuiz, setPourcentageQuiz] = useState(null);

  const [forwardList, setForwardList] = useState([]);
  const [open, setOpen] = useState(false);
  const [questions, setQuestions] = useState([
    data?.usecases[activeStep]?.questions[0],
  ]);
  const [threshold, setThreshold] = useState(0);
  const [progression, setProgression] = useState([]);
  const [answersQuestions, setAnswersQuestions] = useState({});

  useEffect(() => {
    let theProgress = [];

    Object.keys(initialThreshold).map((el) => {
      if (
        Number(initialThreshold[el]) >=
          data?.usecases?.find((item) => item.id === Number(el))?.threshold ||
        data?.usecases
          ?.find((item) => item.id === Number(el))
          ?.questions.map((el) => el.id)
          .every((e) => !!initialPayload[e])
      ) {
        return (theProgress = [...theProgress, Number(el)]);
      }
    });

    if (
      Object.keys(initialThreshold).length > 0 &&
      Object.keys(initialPayload)
    ) {
      setProgression(
        theProgress.concat(
          progression.filter((item) => !theProgress.includes(item)),
        ),
      );
    }
  }, [initialPayload, initialThreshold]);

  useEffect(() => {
    if (answers && Object.keys(answers)?.length !== 0) {
      setAnswersQuestions(answers?.questions);
    }
  }, [answers]);

  const handleForwarded = (items) => {
    setForwarded(items);
    if (!forwardedUseCase.includes(filtredUseCases[activeStep])) {
      setForwardedUseCase([...forwardedUseCase, filtredUseCases[activeStep]]);
      setForwardedUseCaseQuestions([
        ...forwardedUseCaseQuestions,
        ...filtredUseCases[activeStep].questions,
      ]);
      setcurrentUseCase(filtredUseCases[activeStep]);
    }
  };

  // useEffect(() => {
  //   setQuestions(data.usecases[activeStep].questions[0]);
  // }, [data.usecases[activeStep].questions]);

  const handleForwardList = (list) => {
    setForwardList(list);
  };

  useEffect(() => {
    if (forwardedUseCaseQuizzData) {
      setForwardedUseCase(forwardedUseCaseQuizzData);
    }
  }, [forwardedUseCaseQuizzData]);

  useEffect(() => {
    setForwardList(
      forwarded.map((el) => ({
        usecase_id: el.usecase_id,
        forwarded_to: el.email,
        answered: false,
        threshold: el.threshold,
      })),
    );
  }, [forwarded]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemoveLists = () => {
    setForwarded([]);
    setForwardList([]);
  };
  useEffect(() => {
    setPourcentageQuiz(
      Math.round((progression.length * 100) / data?.usecases.length),
    );
  }, [stepsData]);

  useEffect(() => {
    if (data?.answers && Object.values(data?.answers)?.includes(0)) {
      const arr = data?.usecases?.map((el) =>
        el?.questions?.map((el) => ({
          id: el?.id,
          title: el?.title,
          title_fr: el?.title_fr,
        })),
      );
      const questions = arr[0]
        .concat(arr[1])
        .filter((item) => data?.answers[item.id] === 0);
      setForwarded(
        data?.forwarded_question?.forwarded_questions?.map((el) => ({
          fullName: `${
            allUsers?.find((item) => el.forwarded_to === item.email)?.first_name
          } ${
            allUsers?.find((item) => el.forwarded_to === item.email)?.last_name
          }`,
          email: el.forwarded_to,
          idQuestion: el.question_id,
          title: questions.find((item) => el.question_id === item.id)?.title,
          title_fr: questions.find((item) => el.question_id === item.id)
            ?.title_fr,
        })),
      );
    }
  }, [data, allUsers]);

  const toggleAside = () => setIsOpen((prevIsOpen) => !prevIsOpen);

  const isXsMobile = useMediaQuery("(max-width:400px)");

  useEffect(() => {
    return () => {
      dispatch(resetQuizData());
    };
  }, []);

  const scrollToQuestion = (index) => {
    myRefs.current[index].current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleClickQuestion = (index) => {
    setCurrentQuestion(index);
    scrollToQuestion(index);
  };
  const orga = useSelector((state) => state.organizationProfile);

  useEffect(() => {
    dispatch(getOrganizationProfileById(orgaId, true));
  }, [dispatch, orgaId]);

  const goToDashbord = () => {
    if (
      (!Object.keys(payload).every(
        (value, index) => value === Object.keys(answersQuestions)[index],
      ) &&
        !quizDisabed) ||
      (forwarded.length > 0 &&
        forwarded.length !==
          data?.forwarded_question?.forwarded_questions?.length)
    ) {
      setShowPrompt(true);
    } else {
      history.push("/quizzes");
    }
  };

  useEffect(() => {
    if (thresholdsPayload) {
      setThreshold(thresholdsPayload[data?.usecases[activeStep]?.id] || 0);
    }
  }, [activeStep]);

  const handleQuestion = (question, answer, index, weight) => {
    const res = {
      ...payload,
      [question.id]: { choice: answer, weight: weight },
    };

    var nextThreshold = payload[question.id]?.weight
      ? threshold - payload[question.id]?.weight + weight
      : threshold + weight;

    let filterdAll = data.usecases[activeStep].questions.filter(
      (allItem) => question.id < allItem.id,
    );
    filterdAll.map((el) => {
      res[el.id] && (nextThreshold = nextThreshold - res[el.id]?.weight);
      delete res[el.id];
    });
    if (questions.some((el) => el.id > question.id)) {
      setQuestions(questions.filter((el) => el.id <= question.id));
    }
    setPayload(res);
    setThreshold(nextThreshold);

    if (
      index < data.usecases[activeStep].questions.length - 1 &&
      nextThreshold < data.usecases[activeStep].threshold
    ) {
      setQuestions(questions.splice(index + 1));
      const nextElement = data.usecases[activeStep].questions[index + 1];
      setQuestions([...questions, nextElement]);
      setProgression(
        progression.filter((el) => el !== data.usecases[activeStep].id),
      );
    } else {
      setFiltredUseCases(
        filtredUseCases.map((el, index) => {
          if (index === activeStep) {
            if (questions.some((el) => el.id > question.id)) {
              return {
                ...el,
                questions: questions.filter((el) => el.id <= question.id),
              };
            } else {
              return { ...el, questions: questions };
            }
          }
          return { ...el };
        }),
      );
      if (activeStep !== data.usecases.length - 1) {
        handleNext();
      }
      if (!progression.includes(data.usecases[activeStep].id)) {
        setProgression([...progression, data.usecases[activeStep].id]);
      }
    }
    setThresholdsPayload({
      ...thresholdsPayload,
      [data.usecases[activeStep].id]: nextThreshold,
    });
  };

  useEffect(() => {
    if (data.usecases.length !== 0) {
      setCurrentQuestion(questions.length - 1);
      scrollToQuestion(questions.length - 1);
    }
  }, [questions]);

  const removeKeyFromObject = (obj, key) => {
    const { [key]: _, ...newObj } = obj;
    return newObj;
  };

  const removeAnswer = (currentUseCase) => {
    currentUseCase?.questions?.forEach((el) => {
      setPayload((prevState) => removeKeyFromObject(prevState, el.id));
    });
    setThresholdsPayload((prevState) =>
      removeKeyFromObject(prevState, currentUseCase.id),
    );
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setCurrentQuestion(0);
    scrollToQuestion(0);
    setThreshold(0);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCurrentQuestion(0);
    scrollToQuestion(0);
  };

  const handleChangeStep = (index) => {
    setActiveStep(index);
    setCurrentQuestion(0);
    scrollToQuestion(0);
  };

  const handleLeave = () => {
    history.goBack();
  };

  useEffect(() => {
    const initialData = data?.usecases[activeStep]?.questions;
    if (
      data?.usecases[activeStep]?.questions?.some((el) =>
        Object.keys(payload)?.some((item) => el.id === Number(item)),
      )
    ) {
      setQuestions(
        thresholdsPayload[data?.usecases[activeStep]?.id] <
          data?.usecases[activeStep]?.threshold &&
          initialData.length >
            data?.usecases[activeStep]?.questions?.filter((el) =>
              Object.keys(payload).includes(el.id.toString()),
            ).length
          ? [
              ...data?.usecases[activeStep]?.questions?.filter((el) =>
                Object.keys(payload).includes(el.id.toString()),
              ),
              initialData.find(
                (el) =>
                  el.id ===
                  data?.usecases[activeStep]?.questions?.filter((el) =>
                    Object.keys(payload).includes(el.id.toString()),
                  )[
                    data?.usecases[activeStep]?.questions?.filter((el) =>
                      Object.keys(payload).includes(el.id.toString()),
                    ).length - 1
                  ].id +
                    1,
              ),
            ]
          : data?.usecases[activeStep]?.questions?.filter((el) =>
              Object.keys(payload).includes(el.id.toString()),
            ),
      );
    } else {
      setQuestions([data?.usecases[activeStep]?.questions[0]]);
    }
    setcurrentUseCase(data?.usecases[activeStep]);
  }, [activeStep]);

  const handleSubmit = () => {
    if (isAuth) {
      dispatch(
        requestSubmitAnswersQuiz(
          {
            quiz_id: is_completed ? Number(params.quizId) : data.id,
            answers: { questions: payload, usecases: thresholdsPayload },
            is_completed: true,
            version: data.version,
            identifier: data.identifier,
            pourcentage: Math.round(
              (progression.length * 100) / data?.usecases.length,
            ),
          },
          history,
          isAuth,
          orgaId,
          accountType,
        ),
      );
    } else {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getQuestionsNumbers = () => {
    const number = data.usecases.reduce((a, b) => {
      return a + b?.questions?.length;
    }, 0);
    return number;
  };

  useEffect(() => {
    if (data.id) {
      setStepsData(filtredUseCases);
    }
  }, [data.id, filtredUseCases]);

  useEffect(() => {
    if (Object.keys(initialPayload).length !== 0) {
      setStepsData(
        filtredUseCases.map((usecase) => ({
          ...usecase,
          questions:
            thresholdsPayload[usecase.id] >= usecase.threshold
              ? usecase.questions.filter((el) => !!initialPayload[el.id])
              : usecase.questions,
        })),
      );
    }
  }, [initialPayload]);

  const saveAnswer = () => {
    if (forwarded.length > 0) {
      setOpen(true);
    } else {
      dispatch(
        requestAddAnswersQuiz(
          {
            quiz_id: Number(params.quizId) || data.quiz_id,
            answers: { questions: payload, usecases: thresholdsPayload },
            pourcentage: Math.round(
              (progression.length * 100) / data?.usecases.length,
            ),
            is_completed: false,
            version: data.version,
            identifier: data.identifier,
          },
          orgaId,
          accountType,
          history,
        ),
      );
    }
  };

  const { t } = useTranslation();
  return (
    <div
      className={`container-shadow ${isMobile && isOpen ? "aside-open" : ""}`}
      style={{ display: "flex", height: isMobile ? "80vh" : "100vh" }}
    >
      <Stepper
        goToDashbord={() => goToDashbord()}
        quizDecription={data[translate("description")] || t("not_specified")}
        quizTitle={data[translate("title")] || t("not_specified")}
        payload={payload}
        activeStep={activeStep}
        questionNumbers={getQuestionsNumbers()}
        steps={stepsData}
        currentQuestion={currentQuestion}
        handleClickQuestion={(index) => handleClickQuestion(index)}
        changeStep={(index) => handleChangeStep(index)}
        isMobile={isMobile}
        isOpen={isOpen}
        thresholdsPayload={thresholdsPayload}
        toggleAside={toggleAside}
        version={data.version}
        difficultyLevel={data.difficulty_level}
        is_completed={is_completed}
        forwarded={forwarded}
        submissionDate={data.timestamp}
        duration={data?.duration}
        totalUseCases={
          stepsData.map((step, index) =>
            step.questions.map((el) => el.id).every((e) => !!payload[e]),
          ).length
        }
        answredUseCases={
          stepsData
            .map((step, index) =>
              step.questions.map((el) => el.id).every((e) => !!payload[e]),
            )
            .filter((el) => el).length
        }
      ></Stepper>
      {data?.usecases && !!data?.usecases.length ? (
        <div style={{ padding: "20px", flexGrow: isMobile ? 1 : "auto" }}>
          {/* <Navbar /> */}
          {isMobile && (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormatListNumberedIcon onClick={toggleAside} />
              {/* <LanguageSelect /> */}
            </div>
          )}
          <div
            style={{
              padding: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {!isMobile && (
                <span
                  style={{
                    fontFamily: "Bebas Neue, cursive",
                    fontSize: "32px",
                    paddingRight: "10px",
                  }}
                >
                  Cytailor
                </span>
              )}
              <LinearProgressBar
                value={
                  // data?.pourcentage ||
                  Math.round((progression.length * 100) / data?.usecases.length)
                }
              ></LinearProgressBar>
              <span
                style={{
                  fontFamily: "Bebas Neue, cursive",
                  fontSize: "32px",
                  paddingLeft: "10px",
                  marginRight: "15px",
                }}
              >
                {
                  // Math.round(data?.pourcentage) ||
                  Math.round((progression.length * 100) / data?.usecases.length)
                }
                %{" "}
              </span>
              {/* {!isMobile && <LanguageSelect />} */}
            </div>
            {isMobile ? (
              showMore ? (
                <>
                  <span style={{ color: "#8D8482", fontSize: "9px" }}>
                    {t("error_translation")}
                  </span>
                  &nbsp;
                  <span
                    style={{ fontSize: "9px" }}
                    onClick={() => setShowMore(false)}
                  >
                    {t("see_less")}
                  </span>
                </>
              ) : (
                <>
                  <span style={{ color: "#8D8482", fontSize: "9px" }}>
                    {t("error_translation").substring(0, 65)}...
                  </span>
                  &nbsp;
                  <span
                    style={{ fontSize: "9px" }}
                    onClick={() => setShowMore(true)}
                  >
                    {t("see_more")}
                  </span>
                </>
              )
            ) : (
              <>
                <span style={{ color: "#8D8482", fontSize: "12px" }}>
                  {t("error_translation")}
                </span>
              </>
            )}
          </div>
          <div
            style={{
              padding: "10px",
              overflow: "auto",
              height: `${
                isMobile
                  ? "100%"
                  : is_completed
                    ? "calc(100vh - 160px)"
                    : "calc(100vh - 240px)"
              } `,
              width: isMobile ? "100%" : "calc(100vw - 500px)",
            }}
          >
            {questions?.map((el, i) => (
              <div key={i}>
                <MainQuestion
                  is_completed={is_completed}
                  questionsCount={questions?.length}
                  myAnswer={payload[el?.id]}
                  handleQuestion={(question, answer, index, weight) =>
                    handleQuestion(question, answer, index, weight)
                  }
                  currentQuestion={currentQuestion}
                  questionIndex={i}
                  question={el}
                  key={el?.id}
                  ref={myRefs.current[i]}
                  quizDisabed={quizDisabed}
                  forwarded={forwarded}
                  handleForwarded={handleForwarded}
                  removeAnswer={removeAnswer}
                  allUsers={allUsers}
                  handleQuestions={setQuestions}
                  questions={questions}
                  forwardedUseCaseQuestions={forwardedUseCaseQuestions}
                  setForwardedUseCaseQuestions={setForwardedUseCaseQuestions}
                  setForwardedUseCase={setForwardedUseCase}
                  currentUseCase={currentUseCase}
                  forwardedUseCase={forwardedUseCase}
                  setProgression={setProgression}
                  progression={progression}
                  forwardId={data?.forward_id}
                  isAllowed={isAllowed}
                  pendingQuizz={pendingQuizz}
                ></MainQuestion>{" "}
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {!is_completed && (
              <div
                style={{
                  display: "flex",
                  padding: isMobile ? "0 0px 20px 10px" : "20px 0px 20px 20px",
                  justifyContent: "space-between",
                  gap: isMobile ? 5 : 0,
                  width: "30%",
                }}
              >
                <Button
                  color="secondary"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  style={{
                    width: isMobile ? "50%" : "190px",
                    fontSize: isMobile && "10px",
                  }}
                  variant="outlined"
                >
                  {t("previous")}
                </Button>{" "}
                {activeStep === data.usecases.length - 1 ? (
                  Math.round(
                    (progression.length * 100) / data?.usecases.length,
                  ) === 100 && !Object.values(payload).includes(0) ? (
                    <Button
                      onClick={handleSubmit}
                      disabled={pendingQuizz && !isAllowed}
                      color="secondary"
                      style={{
                        width: isMobile ? "50%" : "190px",
                        fontSize: isMobile && "10px",
                      }}
                      variant="contained"
                    >
                      {t("submit")}
                    </Button>
                  ) : (
                    <Tooltip
                      title={
                        <h3>
                          {isAllowed
                            ? t(
                                "you_should_answer_to_all_questions_before_submit",
                              )
                            : t("you_are_not_allowed")}
                        </h3>
                      }
                    >
                      <span>
                        <Button
                          disabled
                          color="secondary"
                          style={{
                            width: isMobile ? "50%" : "190px",
                            fontSize: isMobile && "10px",
                          }}
                          variant="contained"
                        >
                          {t("submit")}
                        </Button>
                      </span>
                    </Tooltip>
                  )
                ) : (
                  <Button
                    onClick={handleNext}
                    color="secondary"
                    style={{
                      width: isMobile ? "50%" : "190px",
                      fontSize: isMobile && "10px",
                    }}
                    variant="contained"
                  >
                    {t("next")}
                  </Button>
                )}
              </div>
            )}
            {isAuth && !is_completed && (
              <div>
                <Button
                  disabled={
                    (Object.keys(payload).every(
                      (value, index) =>
                        value === Object.keys(answersQuestions)[index] &&
                        answersQuestions[value].choice ===
                          payload[value].choice,
                    ) &&
                      !forwarded?.length > 0) ||
                    forwarded?.length ===
                      data?.forwarded_question?.forwarded_questions?.length
                  }
                  onClick={saveAnswer}
                  style={{
                    width: isMobile ? "80%" : "190px",
                    fontSize: isMobile && "10px",
                  }}
                  variant="contained"
                  startIcon={<SaveAsOutlinedIcon />}
                  color="secondary"
                >
                  {t("save")}
                </Button>
              </div>
            )}
          </div>

          <EmailDialogForm
            payload={payload}
            handleClose={handleCloseDialog}
            open={openDialog}
            quiz_id={params.quizId}
            isAuth={isAuth}
            thresholdsPayload={thresholdsPayload}
          ></EmailDialogForm>
          <RouterPrompt
            setShowPrompt={(state) => setShowPrompt(state)}
            when={showPrompt}
            title={t("leave_this_page")}
            onOK={() => history.goBack()}
            onCancel={() => false}
            text={t(
              "there_are_unsaved_changes_are_you_sure_want_to_leave_this_page",
            )}
            saveAnswer={saveAnswer}
            forwarded={forwarded}
            handleLeave={handleLeave}
          />
        </div>
      ) : (
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            padding: isAuth ? "30px" : "30px 300px",
            height: isAuth ? "calc(100vh - 60px)" : "calc(100vh - 124px)",
            overflow: "auto",
          }}
        >
          <SadAvatar
            label="there is no use case yet !!"
            alt="NO Cases"
          ></SadAvatar>
        </Box>
      )}
      {!quizDisabed && (
        <ForwardList
          open={open}
          handleClose={handleClose}
          forwarded={forwarded}
          forwardList={forwardList}
          handleForwardList={handleForwardList}
          quiz_id={Number(params.quizId) || data.quiz_id}
          answers={payload}
          version={data.version}
          identifier={data.identifier}
          forward_id={data.forward_id}
          handleRemoveLists={handleRemoveLists}
          thresholdsPayload={thresholdsPayload}
          pourcentageQuiz={Math.round(
            (progression.length * 100) / data?.usecases.length,
          )}
        />
      )}
    </div>
  );
};

export default MainQuiz;
